module.exports = __webpack_public_path__ + "media/winner_double_line_1.8d841235.mp3";